const items = [
  {
    quote:
      "요구했던 스크린 사이즈 그대로, 균일하게 잘 만들어 주셨어요. 다음 임지 정리 때도 우공이산과 함께할 예정입니다.",
    name: "김OO 과장",
    role: "OO 지역 산림조합",
  },
  {
    quote:
      "800mm 대형 원목이 계속 나오는 현장이었는데도 장비가 밀리지 않고 처리량이 안정적이었습니다. 계획 대비 이틀을 앞당겼습니다.",
    name: "박OO 대표",
    role: "임업 시공사",
  },
  {
    quote:
      "그루터기 파쇄 후 부지 조성까지 매끄럽게 이어졌습니다. 상담·일정·정리 마무리 모두 세심했습니다.",
    name: "이OO 팀장",
    role: "조림·부지 개발 현장",
  },
];

import ScrollReveal from "@/components/ScrollReveal";

export default function Testimonials() {
  return (
    <section className="relative py-24 md:py-32 bg-background-100">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-4">
            <ScrollReveal direction="up" delay={100}>
              <div className="inline-flex items-center gap-2 text-primary-700 text-xs tracking-[0.3em] uppercase font-medium mb-5">
                <span className="w-8 h-px bg-primary-500"></span>
                Client Voices
              </div>
              <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
                현장에서 들려온
                <br />
                <span className="text-primary-700">신뢰의 목소리</span>
              </h2>
              <p className="mt-6 text-foreground-700 text-base md:text-lg leading-relaxed">
                함께 일해 주신 임업 조합, 시공사, 조림 현장의 실제 후기입니다.
              </p>

              <div className="mt-10 p-6 rounded-lg bg-background-50 border border-background-200/70 flex items-center gap-5 shadow-sm">
                <div className="w-14 h-14 rounded-md bg-accent-500 flex items-center justify-center">
                  <i className="ri-star-fill text-background-50 dark:text-foreground-950 text-xl w-6 h-6 flex items-center justify-center"></i>
                </div>
                <div>
                  <div className="font-heading text-3xl font-bold text-foreground-950">
                    4.9 / 5.0
                  </div>
                  <div className="text-foreground-600 text-sm mt-0.5">
                    평균 고객 만족도 (2024 - 2026)
                  </div>
                </div>
              </div>
            </ScrollReveal>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 md:grid-cols-3 gap-6">
            {items.map((t, i) => (
              <ScrollReveal key={t.name} direction="up" delay={200 + i * 150}>
                <div className="p-7 rounded-lg bg-background-50 border border-background-200/70 h-full flex flex-col shadow-sm hover:shadow-md transition-shadow">
                  <i className="ri-double-quotes-l text-4xl text-primary-500/40 w-10 h-10 flex items-center justify-center"></i>
                  <p className="mt-4 text-foreground-800 text-base leading-relaxed flex-1">
                    {t.quote}
                  </p>
                  <div className="mt-6 flex items-center gap-4 pt-6 border-t border-background-200/70">
                    <div className="w-11 h-11 rounded-full bg-primary-500/10 flex items-center justify-center">
                      <i className="ri-user-3-line text-primary-700 w-5 h-5 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <div className="font-heading font-semibold text-foreground-950">
                        {t.name}
                      </div>
                      <div className="text-foreground-600 text-sm">{t.role}</div>
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}